import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import uiReducer from "./slices/uiSlice";
import languageSlice from "./slices/languageSlice";
import globalNotificationsReducer from "./slices/globalNotificationsSlice";
import influencerProfileReducer from "./slices/influencerProfileSlice";
import chatsReducer from "./slices/chatsSlice";

export default configureStore({
    reducer: {
        user: userReducer,
        ui: uiReducer,
        language: languageSlice,
        global_notifications: globalNotificationsReducer,
        influencer_profile: influencerProfileReducer,
        chats: chatsReducer
    },
    devTools: process.env.NODE_ENV === "development" ? true : false
})